import { put, call } from 'redux-saga/effects'
import onlineSalesProcessActions from './onlineSalesProcess.types'



export function* HANDLE_STATE({ field, value }) {
  yield put({
    type: onlineSalesProcessActions.SET_STATE,
    payload: {
      [field]: value,
    },
  })
}

export function* HANDLE_CONTENT({contentStatus='isView'}) {
  yield put({
    type: onlineSalesProcessActions.SET_STATE,
    payload: {
      contentStatus
    },
  })
}

export function* SET_LOADING(loading = false) {
  yield call(HANDLE_STATE, { 'field': 'loading', 'value': loading })
}

export function* SET_ERROR() {
  yield call(SET_LOADING)
}

export const doHandleState = (field, value) => ({
  type: onlineSalesProcessActions.HANDLE_STATE,
  field,
  value
})


export const doSetData = (payload) => ({
  type: onlineSalesProcessActions.HANDLE_STATE,
  field: 'data',
  value: payload
})


export const doGetOnlineSalesPartyAvailability = (payload) => ({
  type: onlineSalesProcessActions.GET_DATA_ONLINE_SALES_PARTY_AVAILABILITY_LIST,
  payload
})

export const doHandleStateOnlineSalesParty = (field, value) => ({
   type: onlineSalesProcessActions.HANDLE_STATE,
  field,
  value
})
